import {hostByBrandByEnv} from '../../../../../hosts'
import {CSP} from '../../../../constants'
import type {Preset} from '../../../../types'

export const AVATARS = {
  [CSP.IMG]: [hostByBrandByEnv.yango.production.avatars],
} as const satisfies Preset
